<div [ngClass]="{'admin-container': !isDialogMode}" [hidden]="!isLoaded">

  <mat-toolbar class="no-background" *ngIf="!isDialogMode">
    <span>【管理者用】出資者情報検索</span>
    <span class="spacer"></span>
    <a mat-button class="add-link" routerLink="/admin">
      <mat-icon>arrow_back</mat-icon>戻る
    </a>
  </mat-toolbar>

  <div class="search-box">
    <mat-form-field appearance="outline">
      <mat-label>ログインID（部分一致）</mat-label>
      <input matInput [(ngModel)]="login">
    </mat-form-field>

    <div style="margin-top: 20px;">AND</div>

    <mat-form-field appearance="outline">
      <mat-label>氏名（部分一致）</mat-label>
      <input matInput [(ngModel)]="name">
    </mat-form-field>

    <div style="margin-left: 20px; margin-top: 20px;">または</div>

    <mat-form-field appearance="outline" style="width: 260px;">
      <mat-label>口座番号（枝番直前まで必須）</mat-label>
      <input matInput [(ngModel)]="cap_id">
    </mat-form-field>

    <button mat-raised-button color="primary" type="submit" [disabled]="!login && !name && !cap_id" (click)="search()">
      検索
    </button>
  </div>

  <div class="list">
    @if (searchUsers && searchUsers.length > 0) {
    <div class="table-container">
      <table border="1" class="account">
        <thead>
          <tr>
            <th>uid</th><th>login</th><th>name</th><th>mail</th><th>月報</th>
          </tr>
        </thead>
        <tbody>
          @for (user of searchUsers; track user) {
            <tr (click)="setUser(user)">
              <td>{{user.id}}</td>
              <td>{{user.login}}</td>
              <td>{{user.name}}</td>
              <td>{{user.mail}}</td>
              <td nowrap>
                <a (click)="blankOpen($event, '/client/monthlyReport?uid=' + user.id)">月報</a>　
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    }
    @else if (searchUsers !== undefined) {
      <div>検索条件に合致する出資者は見つかりませんでした</div>
    }

  </div>

  <div class="info-container" *ngIf="user">

    <app-user-info
      [id]="user.id"
      [title]="user.name + ' (' + user.login + ')様　Email: ' + user.mail"
      [user_id]="user.id"
      [email]="user.mail"
      [isEnableEmailUpdate]="true"
      [abh_key]="user.login"
      [isExpanded]="true"
    ></app-user-info>

  </div>

</div>
